// Variables
const blocks = document.querySelectorAll(".related-income-fund-properties-grid")

for (let i = 0; i < blocks.length; i++) {
    const block = blocks[i]
    const baseId = block.getAttribute('id')
    const gridTwoColumnsButton = document.getElementById(baseId + 'ResultsTwoColumns')
    const gridThreeColumnsButton = document.getElementById(baseId + 'ResultsThreeColumns')
    const resultsWrapper = document.getElementById(baseId + 'Results')
    let mapTimeout = false

    function twoColumns() {
        if(resultsWrapper.classList.contains('lg:!grid-cols-3') || !resultsWrapper.classList.contains('lg:!grid-cols-2')) {
            resultsWrapper.classList.add('lg:!grid-cols-2')
            resultsWrapper.classList.remove('lg:!grid-cols-3')
            gridTwoColumnsButton.classList.add('active')
            gridThreeColumnsButton.classList.remove('active')
        }
    }

    function threeColumns() {
        if(resultsWrapper.classList.contains('lg:!grid-cols-2') || !resultsWrapper.classList.contains('lg:!grid-cols-3')) {
            resultsWrapper.classList.add('lg:!grid-cols-3')
            resultsWrapper.classList.remove('lg:!grid-cols-2')
            gridThreeColumnsButton.classList.add('active')
            gridTwoColumnsButton.classList.remove('active')
        }
    }

    gridTwoColumnsButton.addEventListener('click', twoColumns)
    gridThreeColumnsButton.addEventListener('click', threeColumns)
}